/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-implant-return-bill-item.reducer';

export const PharmacyImplantReturnBillItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyImplantReturnBillItemEntity = useAppSelector(state => state.pharmacyImplantReturnBillItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyImplantReturnBillItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.detail.title">PharmacyImplantReturnBillItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.id}</dd>
          <dt>
            <span id="chargedMrp">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.chargedMrp">Charged Mrp</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.chargedMrp}</dd>
          <dt>
            <span id="returnClaimed">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.returnClaimed">Return Claimed</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.returnClaimed}</dd>
          <dt>
            <span id="returnQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.returnQty">Return Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.returnQty}</dd>
          <dt>
            <span id="manufacDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.manufacDate">Manufac Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.manufacDate}</dd>
          <dt>
            <span id="expDate">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.expDate">Exp Date</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.expDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.cursor}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.lastUpdated}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.pharmacyStock">Pharmacy Stock</Translate>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.pharmacyStock ? pharmacyImplantReturnBillItemEntity.pharmacyStock.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyImplantReturnBillItem.returnBill">Return Bill</Translate>
          </dt>
          <dd>{pharmacyImplantReturnBillItemEntity.returnBill ? pharmacyImplantReturnBillItemEntity.returnBill.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-implant-return-bill-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-implant-return-bill-item/${pharmacyImplantReturnBillItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyImplantReturnBillItemDetail;
